import { render, staticRenderFns } from "./private_letter.vue?vue&type=template&id=c1b8eab0&scoped=true"
import script from "./private_letter.vue?vue&type=script&lang=ts"
export * from "./private_letter.vue?vue&type=script&lang=ts"
import style0 from "./private_letter.vue?vue&type=style&index=0&id=c1b8eab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b8eab0",
  null
  
)

export default component.exports